import { animated } from '@react-spring/web';
import cx from 'clsx';
import React, { type ReactElement } from 'react';

import useGetTextAppearanceAnimation from '@pages/Root/hooks/useGetTextAppearanceAnimation';

import { selectAppPersistSidebarResponse } from '@store/useAppStorePersist';

import style from './style.module.scss';

interface IProps {
  text: string;
  id?: string;
  tooltipId: string;
  icon: ReactElement;
  className?: string;
  children?: ReactElement;
  onClick?: () => void;
}

const NavButtonItem: React.FC<IProps> = ({ text, id, tooltipId, icon, className, children, onClick }) => {
  const { textAnimationStyles } = useGetTextAppearanceAnimation();

  const sidebarResponse = selectAppPersistSidebarResponse();

  return (
    <div
      id={id}
      className={cx(
        style.navItem,
        {
          [style.closedSidebarNavItem]: sidebarResponse,
        },
        className,
      )}
      data-tooltip-id={tooltipId}
      data-tooltip-content={text}
      onClick={onClick}
    >
      <div>{icon}</div>
      <animated.div style={{ ...textAnimationStyles }}>
        <div className={style.textContainer}>{children || text}</div>
      </animated.div>
    </div>
  );
};

export default NavButtonItem;
